import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from './actions/userActions';

export const AuthenticatedRoute = ({ component: Component, ...rest }) => {
  const attrs = { ...rest };

  if (attrs.action && attrs.action === 'logout') {
    attrs.userLogout();
  }

  const userAuthInfo = localStorage.getItem('userAuthInfo');

  return (
    <Route
      {...attrs}
      render={props => (
        userAuthInfo ? <Component {...props} /> : <Redirect to="/" />
      )}
    />
  )
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  userLogout: userActions.userLogout
})(AuthenticatedRoute);